export const ANNOTATION_KEY_POD_NAME_VERSION = 'workflows.argoproj.io/pod-name-format';
export const ANNOTATION_TITLE = 'workflows.argoproj.io/title';
export const ANNOTATION_DESCRIPTION = 'workflows.argoproj.io/description';
